import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { Form, Row, Col } from "react-bootstrap";
import { useForm } from "react-hook-form";
import axios from "axios";
import { showSuccessToast, showErrorToast } from "../../Utils/toastUtils";


const JSON = (props) => {
  const { register, handleSubmit } = useForm();
  const getData = props.getData
  const modal = props.modal
  const setModal = props.setModal
  const [isProcessing, setIsProcessing] = React.useState(false);


  const [comment, setComment] = useState("")


  const cleardata = () => {
    setComment("")

  }
  const handleFormData = () => {

    if (comment.length === 0) {
      showErrorToast("Input comment");
      return 0;
    }


  }

  const submitJSON = (e) => {
    e.preventDefault()
    let a  = handleFormData()
    if(a ===0) return
    setIsProcessing(true)
    console.log("Started uploading json")
    let postData = {
      comment: comment,

    }
    console.log("gone")

    let data = axios.post('/api/makejson',postData, {
      headers: {
        Authorization: 'Bearer ' + sessionStorage.getItem('userToken')
      }
    })
      .then(response => {

        showSuccessToast((response.data && response.data.Message) ? response.data.Message : "Success")
        setIsProcessing(false)
        getData()
        setModal(!modal)

      })
      .catch(error => {
        // Handle error
        showErrorToast("Error in Making JSON");
        setIsProcessing(false)
        setModal(!modal)


        console.error(error);
      });
    console.log("Ending uploading json")


  }


  return (
    <div>
      <Modal size="lg" backdropClassName="" isOpen={modal} toggle={() => setModal(!modal)}>
        <ModalHeader toggle={() => setModal(!modal)}>
          Make JSON
        </ModalHeader>
        <ModalBody >
          <form >
            <div className="input-group input-group-outline my-3">
              <input
                type="text"
                className="form-control"
                placeholder="Comment"
                onChange={(e) => setComment(e.target.value)}
              />
            </div>

            <div className="text-center">
              <button
                type="submit"
                className="btn bg-gradient-info  w-15 my-5 mb-2"
                onClick={(e) => submitJSON(e)}
              >
                {isProcessing ? (
                  // <p className="d-flex flex-row" >
                  <span>Processing</span>
                  // </p>
                ) : (
                  'Make JSON'
                )}
              </button>
            </div>
          </form>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default JSON;
